import { render, staticRenderFns } from "./DeliveryPersonDialog.vue?vue&type=template&id=22f36476&"
import script from "./DeliveryPersonDialog.vue?vue&type=script&lang=js&"
export * from "./DeliveryPersonDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryPersonDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports